__turbopack_context__.v({
  "categoryTitle": "cIE0oW_categoryTitle",
  "categoryTitleLink": "cIE0oW_categoryTitleLink",
  "categoryTitleProductsCount": "cIE0oW_categoryTitleProductsCount",
  "columnsWrapper": "cIE0oW_columnsWrapper",
  "header": "cIE0oW_header",
  "listWrapper": "cIE0oW_listWrapper",
  "listWrapperOpen": "cIE0oW_listWrapperOpen",
});
